import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { GridOptions, RowNode } from 'ag-grid-community';
import { BsModalService,BsModalRef}   from 'ngx-bootstrap/modal';
import { User } from '../../models/user.model';
import { Clinic } from '../../models/clinic.model';
import { AlertService } from '../../util/alert/alert.service';
import { LocalStorage } from '../../util/localstorage.service'; 
import { CommonFunctions } from '../../util/common-functions';
import { UserDataService } from './user-data.service';
import { ClinicDataService } from '../clinic/clinic-data.service';
import { UserCustomCellComponent } from './user-custom-cell/user-custom-cell.component';
import { DatePipe } from '@angular/common';
import { Constants } from '../../util/constants';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  public user:User;
  private gridApi: any;
  private gridColumnApi: any;
  public columnDefs: any;
  public rowData: any;
  public gridOptions : GridOptions
  public defaultColDef
  public id
  public clinicid
  public clinic
  public clinicname
  public clinicfilter
  public clinics: Array<any> =[]
  public userroles: Array<any> =[]
  public clinicsforfilter: Array<any> =[]
  public selectedClinicItem: Array<any> =[]
  public selectedUserRoleItem: Array<any> =[]
  public selectedClinicFilter: Array<any> =[]
  public firstname
  public middlename
  public lastname
  public dob
  public email 
  public phone
  public userroleid
  public updateMode 
  public deleteMode
  public name
  public isAdminUser
  public isUserRoleDisabled
  public userrolename


  private commonFunctions: CommonFunctions = new CommonFunctions
  @ViewChild('add_edit_User') add_edit_User: TemplateRef<any>
  public ModalRef : BsModalRef 

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
    private userService: UserDataService,private clinicService: ClinicDataService,  private bsModalService :BsModalService) {

    var self = this;
    this.gridOptions = {
      rowData: this.rowData,
      columnDefs: this.columnDefs,
      enableColResize: true,
      enableSorting: true,
      rowSelection: "single",
      rowHeight: 35,
      rowDeselection: true,
      animateRows: true,
      rowBuffer: 20,
      context: {
        componentParent: this
      },
      paginationPageSize: 10
    };

    this.defaultColDef = {
      //autoHeight: true,
      resizable: true,
      filter: true,
    };
   }

  ngOnInit(): void {

    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser){
      this.isAdminUser = true
    } else{
      this.isAdminUser = false
    }
    this.iSForm = this.formBuilder.group({
      name: new FormControl(null),
      clinic: new FormControl(null),
      clinicfilter: new FormControl(null),
      clinicname: new FormControl(null),
      userroleid: new FormControl(null),
      userrolename: new FormControl(null),
      firstname: new FormControl(null),
      middlename: new FormControl(null),
      lastname: new FormControl(null),
      dob: new FormControl(null),
      email: new FormControl(null),
      phone: new FormControl(null)
    } ); 

    this.columnDefs = [
      { 
        headerName: 'UserId', 
        field: 'id',
        hide: true
      },
      { 
        headerName: 'ClinicId', 
        field: 'clinicid',
        hide: true
      },
      { 
        headerName: 'Clinic Name', 
        field: 'clinicname',
        width: 30,
        hide: this.isAdminUser
      },
      {
        headerName: 'First Name', 
        field: 'firstname',
        width: 30,
      },
      {
        headerName: 'Middle Name', 
        field: 'middlename',
        hide: true
      },
      { 
        headerName: 'Last Name', 
        field: 'lastname',
        width: 30,
      },
      { 
        headerName: 'Date of Birth', 
        field: 'dob',
        hide: true
      },
      { 
        headerName: 'Email', 
        field: 'email',
        width: 50,
      },
      { 
        headerName: 'Phone', 
        field: 'phone',
        hide: true
      },
      { 
        headerName: 'UserRoleID', 
        field: 'UserRoleID',
        hide: true
      },
      { 
        headerName: 'User Role', 
        field: 'userrolename',
        width: 30
      },
      { 
        headerName: '', 
        field: 'edit_delete',
        width: 30,
        cellStyle: {textAlign: "center"},
        cellRendererFramework: UserCustomCellComponent,
      } ,
      // { 
      //   headerName: 'Delete', 
      //   field: 'delete',
      //   cellStyle: {textAlign: "center"},
      //   width: 40,
      //   cellRenderer: function(params) {
      //     var input2 = document.createElement('input');
      //     input2.type="button";
      //     input2.className = "btn btn-primary btn-sm";
      //     input2.innerHTML = '<i class="far fa-edit"></i> Delete';
      //     input2.style.width = "60px";
      //     document.body.appendChild(input2);
      //     input2.addEventListener('click', function (event) {
      //         self.deleteUser(params.data);												
			// 		});
			// 		return input2						
			// 	}
      // }
    ];
    
    this.loadData()
    this.loadClinicData()
    this.loadUserRoleData()
  }

  externalFilterChanged() {
    if(this.gridApi != undefined){
      this.gridApi.onFilterChanged();
    }  
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass = (node: RowNode): boolean => {
    var Clinicname = node.data.clinicname.toLowerCase()
    var Firstname = node.data.firstname.toLowerCase()
    var Middlename = node.data.middlename.toLowerCase()
    var Lastname = node.data.lastname.toLowerCase()
    var Email = node.data.email.toLowerCase()

    var isClinicFilterNotPresent = (this.clinicfilter == null || this.clinicfilter == undefined || this.clinicfilter == "" || this.clinicfilter == Constants.DefaultValues.DropDownValue)
    var isNameFilterNotPresent = (this.name == null || this.name == undefined || this.name == "")

    if(isClinicFilterNotPresent && isNameFilterNotPresent){
      return true
    } else if (!isClinicFilterNotPresent && isNameFilterNotPresent && Clinicname == this.clinicfilter.toLowerCase()){
        return true
    } else if(!isNameFilterNotPresent && isClinicFilterNotPresent){
      if(Firstname.includes(this.name.toLowerCase()) || Middlename.includes(this.name.toLowerCase()) || Lastname.includes(this.name.toLowerCase()) || Email.includes(this.name.toLowerCase())){
        return true
      }     
    } else if(!isNameFilterNotPresent && !isClinicFilterNotPresent){
      if((Firstname.includes(this.name.toLowerCase()) || Middlename.includes(this.name.toLowerCase()) || Lastname.includes(this.name.toLowerCase()) || Email.includes(this.name.toLowerCase())) && Clinicname == this.clinicfilter.toLowerCase()){
        return true
      }
    }
  }

  sortClinicRemainingFilters(){
    this.clinicsforfilter = []
    this.clinicsforfilter.push({ClinicID: "0", ClinicName: Constants.DefaultValues.DropDownValue, Location: null});
    if((this.selectedClinicFilter["ClinicName"] != Constants.DefaultValues.DropDownValue) && this.selectedClinicFilter != null && this.selectedClinicFilter != undefined && this.selectedClinicFilter.length != 0){
      this.clinics.forEach((element: any) => {
        if(element.ClinicName != this.selectedClinicFilter["ClinicName"]){
          this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
        }
      });
    } else{
      this.clinics.forEach((element: any) => {
          this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
      });
      this.selectedClinicFilter = this.clinicsforfilter[0]
    }
  }

  clinicFilter(): void {
    if(this.selectedClinicFilter != null && this.selectedClinicFilter != undefined){
      this.clinicfilter = this.selectedClinicFilter["ClinicName"]
      this.sortClinicRemainingFilters()
      if(this.clinicfilter != null && this.clinicfilter != undefined && this.clinicfilter != "" && this.clinicfilter != Constants.DefaultValues.DropDownValue){
        this.gridOptions.columnApi.setColumnVisible('clinicname', false)
        this.gridOptions.api.sizeColumnsToFit();
      } else{
        this.gridOptions.columnApi.setColumnVisible('clinicname', true)
        this.gridOptions.api.sizeColumnsToFit();
      }
    } else{
      this.clinicfilter = ""
      this.gridOptions.columnApi.setColumnVisible('clinicname', true)
      this.gridOptions.api.sizeColumnsToFit();
    }
	  this.searchBtnClickEvent()
  }

  loadData()
	{
    this.alertService.clear()
    if(this.isAdminUser){
      this.userService.getUsers(this.loggedUser.ClinicID,this.loggedUser).subscribe(data => this.getData(data))
    } else{
      this.userService.getUsers("0",this.loggedUser).subscribe(data => this.getData(data))
    }
  }
  
  loadClinicData()
	{
    this.alertService.clear()
    this.clinicService.getClinics(this.loggedUser).subscribe(data => this.getClinicData(data))
	}

  loadUserRoleData()
	{
    this.alertService.clear()
    this.userService.getUserRoles(this.loggedUser).subscribe(data => this.getUserRoleData(data))
	}

  public getData(data: any) {
    let users: Array<any>=[] 
    data.forEach((element: any) => {
      //let client: Client = element
      let user: User = element
      user.UserID = element.UserID
      user.ClinicID = element.ClinicID
	    user.ClinicName = element.ClinicName
      user.FirstName = element.FirstName
      user.MiddleName = element.MiddleName
      user.LastName = element.LastName
      var datePipe = new DatePipe('en-US');
      if(datePipe.transform(element.DateOfBirth, 'MM/dd/yyyy') != Constants.Date.MinValue){
        user.DateOfBirth = datePipe.transform(element.DateOfBirth, 'MM/dd/yyyy');
      } else{
        user.DateOfBirth = "";
      }
      
      user.Email = element.Email
      user.Phone = element.Phone
      user.UserRoleID = element.UserRoleID
      var UserRoleName: string
      if(element.UserRoleID == Constants.UserRoleID.SuperUser){
        UserRoleName = Constants.UserRoleName.SuperUser
      } else if(element.UserRoleID == Constants.UserRoleID.AdminUser){
        UserRoleName = Constants.UserRoleName.AdminUser
      } else{
        UserRoleName = Constants.UserRoleName.User
      }
           
      users.push({id: user.UserID, clinicid: user.ClinicID, clinicname: user.ClinicName, firstname: user.FirstName ,middlename: user.MiddleName, lastname: user.LastName,
        dob: user.DateOfBirth, email: user.Email, phone: user.Phone, userroleid: user.UserRoleID, userrolename: UserRoleName})
  
    setTimeout(()=> {
      this.gridApi.forEachNode(node => {
        if ( node.rowIndex  === 0 ){ 
          node.setSelected(true)
          this.id = node.data.UserID
          this.clinicid = node.data.clinicid
		      this.clinicname = node.data.clinicname
          this.firstname = node.data.firstname
          this.middlename = node.data.middlename
          this.lastname = node.data.lastname
          this.dob = node.data.dob
          this.email = node.data.email
          this.phone = node.data.phone
          this.userroleid = node.data.userroleid
          this.updateMode = false
          this.deleteMode = false
        } 
      }); 
    
    }, 50); 

    });
    this.rowData = users;
    this.cancelBtnClickEvent();
    this.initializeUserDetails();
    return this.rowData;
  }

  public getClinicData(data: any) {
    this.clinics = data
    if(!this.updateMode){
      this.clinicsforfilter = []
      this.clinicsforfilter.push({ClinicID: "0", ClinicName: Constants.DefaultValues.DropDownValue});
      this.selectedClinicFilter = this.clinicsforfilter[0]
    }
	
    this.selectedClinicItem = []
    data.forEach((element: any) => {
      if(!this.updateMode){
        this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName});
      }
      if(this.clinicid != null && this.clinicid != undefined && this.clinicid == element.ClinicID){
        if(this.isAdminUser){
          this.clinicname = element.ClinicName
        } else{
          this.selectedClinicItem = element
        }
        
      }
    });
    return this.clinics;
  }

  public getUserRoleData(data: any){
    this.userroles = data
  }

  public selectedUserRole(event: any): void {
    if(this.selectedUserRoleItem != null && this.selectedUserRoleItem != undefined){
      this.userroleid = this.selectedUserRoleItem["UserRoleID"]
    } else{
      this.userroleid = ""
    }
	}

  public selectedClinic(event: any): void {
    if(this.selectedClinicItem != null && this.selectedClinicItem != undefined){
      this.clinicid = this.selectedClinicItem["ClinicID"]
    } else{
      this.clinicid = ""
    }
	}

  initializeUserDetails()
  {
    this.id = ""
    if(this.isAdminUser){
      this.clinicid = this.loggedUser.ClinicID
      this.getClinicData(this.clinics)
    } else{
      this.clinicid = ""
      this.clinic = ""
      this.clinicname = ""
    }
    //this.clinicfilter = Constants.DefaultValues.DropDownValue
    this.selectedClinicItem = []
    //this.selectedClinicFilter = this.clinicsforfilter[0]
    this.firstname = ""
    this.middlename = ""
    this.lastname = ""
    this.email = ""
    this.dob = ""
    this.phone = ""  
    this.userroleid = Constants.UserRoleID.User
    this.selectedUserRoleItem = this.userroles.find(x => x.UserRoleID === Constants.UserRoleID.User)
    this.updateMode = false 
    this.deleteMode = false 
    this.isUserRoleDisabled = false
  }

  cancelBtnClickEvent(){
    this.name = null
    this.clinicfilter = Constants.DefaultValues.DropDownValue
    this.selectedClinicFilter = []
    this.sortClinicRemainingFilters()
    if(!this.isAdminUser){
      this.gridOptions.columnApi.setColumnVisible('clinicname', true)
    } else{
      this.gridOptions.columnApi.setColumnVisible('clinicname', false)
    }
    this.gridOptions.api.sizeColumnsToFit();
    this.externalFilterChanged()
  }
  

  // exitBtnClickEvent(){ 
  //   this.router.navigateByUrl('landing'); 
  // }

  searchBtnClickEvent(){
    this.alertService.clear()
    this.externalFilterChanged()
  }

  editUser(data: any){
    this.alertService.clear()
    this.initializeUserDetails()
    this.id = data.id
    this.firstname = data.firstname
    this.middlename = data.middlename
    this.lastname = data.lastname
	  this.clinicname = data.clinicname
    this.email = data.email
    this.dob = data.dob
    this.phone = data.phone
    this.userroleid = data.userroleid
    this.selectedUserRoleItem = this.userroles.find(x => x.UserRoleID === this.userroleid)
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser && this.userroleid  == Constants.UserRoleID.SuperUser){
      this.isUserRoleDisabled = true
      this.userrolename = "Super User"
    }
    this.updateMode = true  
    if(!this.isAdminUser){
      this.clinicid = data.clinicid
      this.getClinicData(this.clinics)     
    } 
    if(this.id == this.loggedUser.UserID){
      this.router.navigateByUrl('editprofile');
      
    } else{
      this.ModalRef = this.bsModalService.show(this.add_edit_User)
    }
  }

  deleteUser(data: any){
    this.alertService.clear()
    this.initializeUserDetails()
    if (confirm("Are you sure you want to delete selected record?")) { 
      this.id = data.id
      this.clinicid = data.clinicid
      this.firstname = data.firstname
      this.middlename = data.middlename
      this.lastname = data.lastname
      this.email = data.email
      this.dob = data.dob
      this.phone = data.phone
      this.userroleid = data.userroleid
      this.deleteMode = true
      this.saveUserDetails()
    }
  }

  addnewuser(){
    this.alertService.clear()
    this.initializeUserDetails()
    this.ModalRef = this.bsModalService.show(this.add_edit_User)
  }

  onDateOfBirthChange(event){
    this.dob = event
  }

  validateUser():boolean
  { 
    if(!this.deleteMode){
        if(!this.isAdminUser){
          if ((this.iSForm.controls.clinic.value == ""  || 
          this.iSForm.controls.clinic.value == null ))
          { 
            this.alertService.clear()
            this.alertService.error('Invalid Clinic')
            return false
          }
        } else{
          if ((this.iSForm.controls.clinicname.value == ""  || 
          this.iSForm.controls.clinicname.value == null ))
          { 
            this.alertService.clear()
            this.alertService.error('Invalid Clinic')
            return false
          }
        }
        if ((this.iSForm.controls.firstname.value == ""  || 
        this.iSForm.controls.firstname.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid First Name')
          return false
        }     

        if ((this.iSForm.controls.lastname.value == ""  || 
              this.iSForm.controls.lastname.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Last Name')
          return false
        }
        if ((this.iSForm.controls.dob.value != "") && (this.iSForm.controls.dob.value != null) && (this.iSForm.controls.dob.value == "Invalid Date"))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Date of Birth')
          return false
        }
        var emailVal = /\S+@\S+\.\S+/;
        if ((this.iSForm.controls.email.value == ""  || 
        this.iSForm.controls.email.value == null ) || !(emailVal.test(this.iSForm.controls.email.value)))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Email')
          return false
        } else{
            //check for existing email
            var i
            if(!this.updateMode){
              for(i = 0; i < this.rowData.length; i++){
                if(this.iSForm.controls.email.value == this.rowData[i].email){
                  this.alertService.clear()
                  this.alertService.error('Email already exist')
                  return false
                }
              }
            } else{
              for(i = 0; i < this.rowData.length; i++){
                if((this.iSForm.controls.email.value == this.rowData[i].email) && (this.id != this.rowData[i].id)){
                    this.alertService.clear()
                    this.alertService.error('Email already exist')
                    return false      
                }
              }
            }
        }
        var phoneVal = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
        if (this.iSForm.controls.phone.value != null && this.iSForm.controls.phone.value != "") {
          if(!(phoneVal.test(this.iSForm.controls.phone.value))){
            this.alertService.clear()
            this.alertService.error('Invalid Phone Number')
            return false
          }
        }
        if ((this.iSForm.controls.userroleid.value === ""  || 
        this.iSForm.controls.userroleid.value === null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid User Role')
          return false
        }
    } else{
      if (this.id == this.loggedUser.UserID )
        { 
          this.alertService.clear()
          this.alertService.error('Cannot delete the logged in user')
          return false
        }     
    }
    return true
  }

  saveUserDetails(){
    if (this.validateUser()){
      this.user = new User()
      this.user.ClinicID = this.clinicid
      this.user.FirstName = this.firstname
      this.user.MiddleName = this.middlename
      this.user.LastName = this.lastname
      if(this.iSForm.controls.dob.value != null){
        this.user.DateOfBirth = new Date(this.dob).toLocaleDateString()
      } else{
        this.user.DateOfBirth = null
      }
      this.user.Email = this.email
      this.user.Phone = this.phone
      this.user.UserRoleID = Number(this.userroleid)
      this.user.CreatedBy = this.loggedUser.UserID
      this.user.CreatedOn = new Date()
      if(this.id == ""){
        this.user.UserID =  this.commonFunctions.getnewguid() 
      } else{
        this.user.UserID =  this.id
      }
      if(this.deleteMode)
      {
        this.user.bDeleted = Constants.bDeleted.True
        this.user.DeletedBy = this.loggedUser.UserID
        this.user.DeletedOn = new Date()
      } else{
        this.user.bDeleted = Constants.bDeleted.False
      }
      this.userService.saveUser(this.user, this.loggedUser).subscribe(date =>
      {
        this.alertService.clear()
        this.loadData()
        if(this.updateMode && !this.deleteMode){
          this.alertService.success('Successfully updated')
        } else if(this.deleteMode){
          this.alertService.success('Successfully deleted')
        } else{
          this.alertService.success('Successfully saved')
        }
        this.cancelModal()
        
      },
      error => { 
        this.alertService.clear()
        this.loadData()
        this.alertService.error('Error occured while saving data')
          
       });
    }
    
  }

  cancelModal(){
    this.ModalRef.hide()
  }

  gridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
  }

  onGridReady(params: any) { 
    this.rowData = []
		this.gridApi  = params.api;
    this.gridColumnApi = params.columnApi; 
    this.gridApi.sizeColumnsToFit();
  }

}
